<template>
	<v-container fluid>
		<SignalR path="/hub/mantenimiento" @change="onChangeSocket" />
		
		<DialogNotificacion
			id="dialog-notificacion-1"
			ref="dialogAlerta"
			:isMobile="isMobile"
			enableCancel
			@click:aceptar="onClickAceptar"
		/>
		<DialogNotificacion
			id="dialog-notificacion-2"
			ref="dialogSuccess"
			:isMobile="isMobile"
			@click:aceptar="onClickCerrarDialogSuccess"
		/>
		<DialogNotificacion
			id="dialog-notificacion-3"
			ref="dialogInfo"
			:isMobile="isMobile"
		/>
		<v-row justify="center">
			<v-col cols="12">
				<TitleHeader
					title="Tarea de Mantenimiento en Progreso"
					:loading="loading || saving || leaving"
					:isMobile="isMobile"
					@click:btn="onRefresh()"
				/>
			</v-col>
		</v-row>
		<template v-if="!loading">
			<v-row justify="center">
				<v-col :cols="isMobile ? '12' : '6'">
					<ActividadTable
						:actividad="actividad"
						:inicioCronometro="inicioCronometro"
						enCurso
						class="elevation-2"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-divider class="divider-dashed" />
				</v-col>
			</v-row>
		</template>
		<template v-if="loading">
			<LoadingData :isMobile="isMobile" />
		</template>
		<template v-if="hayComprobaciones">
			<template v-for="(comprobacion, index) in comprobaciones">
				<ComprobacionItem
					:isMobile="isMobile"
					:key="`comp-${index}`"
					:comprobacion="comprobacion"
					:disabled="saving || leaving"
				/>
				<v-row :key="`divider-${index}`">
					<v-col cols="12">
						<v-divider class="divider-dashed" />
					</v-col>
				</v-row>
			</template>
		</template>
		<template v-if="noHayComprobaciones">
			<NoData
				:isMobile="isMobile"
				text="No hay comprobaciones disponibles"
				reduced
			/>
			<v-row>
				<v-col cols="12">
					<v-divider class="divider-dashed" />
				</v-col>
			</v-row>
		</template>
		<template v-if="!loading">
			<v-row v-if="esIndasa && actividad.tipo != 4">
				<v-col v-if="esCategoriaEspecifica('transportes')" cols="12">
					<KilometrajeTextfield
						v-model="kilometraje"
						outlined
						class="custom-error-message"
						:kilometrajeMin.sync="kilometrajeMin"
						:idMaquinaInstancia="actividad.idMaquinaInstancia"
						:error-messages.sync="erroresItem.errorKilometraje"
						:loadingKilometrajeMin.sync="loadingKilometrajeMin"
						:disabled="saving || leaving"
					/>
					<v-divider />
				</v-col>
				<v-col v-else-if="esCategoriaEspecifica('montacargas')" cols="12">
					<v-text-field
						v-model="horasTrabajadas"
						label="Horas Trabajadas"
						type="number"
						outlined
						hide-spin-buttons
						clearable
						class="custom-error-message"
						:disabled="saving || leaving"
						:error-messages="erroresItem.errorHorasTrabajadas"
						@focus="erroresItem.errorHorasTrabajadas = null"
					></v-text-field>
					<v-divider />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-textarea
						v-model="recomendacion"
						label="Descripcion o recomendación general"
						outlined
						clearable
						auto-grow
						rows="3"
						class="custom-error-message"
						:disabled="saving || leaving"
						:error-messages="erroresItem.errorRecomendacion"
						@focus="erroresItem.errorRecomendacion = null"
					></v-textarea>
				</v-col>
				<v-divider class="mx-4 mb-3" />
			</v-row>
			<v-slide-y-transition>
				<v-row v-if="errores.length > 0">
					<v-col cols="12">
						<p
							v-for="error,idx in errores"
							:key="`error-${idx}`"
							class="error--text"
							:class="{
								'mb-0': errores.length == 1,
								'mb-1': errores.length > 1
							}"
							>{{ error }}</p
						>
					</v-col>
				</v-row>
			</v-slide-y-transition>
			<v-row
				justify="center"
				class="align-center mt-0"
				:class="{
					'pt-8': isMobile && hayComprobaciones,
					'pt-16': !isMobile && hayComprobaciones,
				}"
			>
				<v-col
					v-if="mecanicos.length > 1"
					:cols="isMobile ? '12' : '6'"
				>
					<v-btn
						color="primary"
						block
						large
						@click="onClickSalir()"
						:disabled="saving || leaving || loadingKilometrajeMin"
						:loading="leaving"
					>
						Salir
					</v-btn>
				</v-col>
				<v-col
					v-if="pausarActividadMtto"
					:cols="isMobile ? '12' : '6'"
				>
					<v-btn
						color="warning"
						block
						large
						@click="onClickPausar()"
						:disabled="saving || leaving || loadingKilometrajeMin"
						:loading="leaving"
					>
						Pausar
					</v-btn>
				</v-col>
				<v-col :cols="isMobile ? '12' : '6'">
					<v-btn
						color="success"
						block
						large
						@click="onClickFinalizar()"
						:disabled="saving || leaving || loadingKilometrajeMin"
						:loading="saving"
					>
						Finalizar
					</v-btn>
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
import axios from "axios";
import ActividadTable from "../shared/ActividadTable.vue";
import TitleHeader from "../shared/TitleHeader.vue";
import ComprobacionItem from "./ComprobacionItem.vue";
import LoadingData from "../shared/LoadingData.vue";
import NoData from "../shared/NoData.vue";
import DialogNotificacion from "../shared/DialogNotificacion.vue";
import SignalR from "../../SignalR.vue";
import { mapActions, mapState } from 'vuex';
import KilometrajeTextfield from '../shared/KilometrajeTextfield.vue';

export default {
	props: {
		actividad: {
			type: Object,
			required: true,
		},
	},
	components: {
		TitleHeader,
		ActividadTable,
		ComprobacionItem,
		LoadingData,
		NoData,
		DialogNotificacion,
		SignalR,
		KilometrajeTextfield
	},
	data() {
		return {
			loadingKilometrajeMin: false,
			kilometrajeMin: null,
			kilometraje: null,
			horasTrabajadas: null,
			erroresItem: {
				errorKilometraje: null,
				errorHorasTrabajadas: null,
				errorRecomendacion: null
			},
			errores: [],
			saving: false,
			loading: false,
			comprobaciones: [],
			mecanicos: [],
			recomendacion: null,
			leaving: false,
			inicioCronometro: 0,
		};
	},
	mounted() {
		this.initialize();
	},
	computed: {
		...mapState(['tiposEstados','nombreEmpresa','pausarActividadMtto']),
		esIndasa(){
			return this.nombreEmpresa.toUpperCase() == "INDASA";
		},
		hayComprobaciones() {
			return !this.loading && this.comprobaciones.length > 0;
		},
		noHayComprobaciones() {
			return !this.loading && this.comprobaciones.length == 0;
		},
		isMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
	},
	methods: {
		...mapActions(['getParsedParams']),
		esCategoriaEspecifica(categoria){
			return this.actividad.maquinaCategoria.toLowerCase().trim() == categoria.toLowerCase().trim();
		},
		async onChangeSocket(event) {
			const parsedParams = await this.getParsedParams(event);

			const dynamicKey =
				this.actividad.tipo == 3
					? "idMantenimientoCalendarioInspeccion"
					: "idMantenimientoTarea";

			if (parsedParams[dynamicKey] != this.actividad[dynamicKey]) return;

			if (parsedParams.estado == this.tiposEstados["unirse"]) {
				this.$refs.dialogInfo.showDialogNotificacion(
					"Un usuario se ha unido",
					"Un usuario se ha unido a la actividad",
					"mdi-account-multiple-plus",
					"primary"
				);
				this.getComprobaciones(true);
			} else if (parsedParams.estado == this.tiposEstados["salirse"]) {
				this.$refs.dialogInfo.showDialogNotificacion(
					"Un usuario ha salido",
					"Un usuario ha salido de la actividad",
					"mdi-account-multiple-minus",
					"primary"
				);
				this.getComprobaciones(true);
			} else if (parsedParams.estado == this.tiposEstados["finalizar"]) {
				if(parsedParams.idPersonaDisparo != this.actividad.idPersona)
					this.$refs.dialogSuccess.showDialogNotificacion(
						"Reporte enviado",
						"Un usuario ha enviado el reporte de comprobaciones",
						"mdi-check-circle",
						"success"
					);
			} else if (parsedParams.estado == this.tiposEstados["pausar"]) {
				if(parsedParams.idPersona != this.actividad.idPersona){
					this.$refs.dialogSuccess.showDialogNotificacion(
						"Actividad pausada",
						"Un usuario ha pausado la actividad",
						"mdi-pause-circle",
						"warning"
					);
					this.onClickSalir();
				}
			}
		},
		onClickAceptar() {
			this.enviarComprobaciones();
		},
		onClickCerrarDialogSuccess() {
			this.$emit("click:finalizar");
			setTimeout(() => {
				this.resetValores();
			}, 200);
		},
		validatePausar() {
			this.resetErrores();
			let hayErroresComprobaciones = false;

			this.comprobaciones.forEach((comprobacion) => {

				if(comprobacion.respuesta && comprobacion.satisfactoria == null){
					this.$set(comprobacion, "errorSatisfactoria", "Requerido");
					hayErroresComprobaciones = true;
				}

				if(
					comprobacion.tipoComprobacion != null &&
					!comprobacion.respuesta &&
					comprobacion.satisfactoria != null
				){
					this.$set(comprobacion, "errorRespuesta", "Requerido");
						hayErroresComprobaciones = true;
				}
				
				if (comprobacion.satisfactoria == false && comprobacion.resuelto == null) {
					this.$set(comprobacion, "errorResuelto", "Requerido");
					hayErroresComprobaciones = true;
				}
			});

			let hayErrores = Object.values(this.erroresItem).some( value => value != null) || hayErroresComprobaciones;

			if(hayErrores) this.errores = ["Hay uno o mas errores, porfavor reviselos y vuelva a intentarlo"];

			return !hayErrores;
		},
		onClickPausar(){
			if(!this.validatePausar()) return;
			this.leaving = true;

			const comprobaciones = this.comprobaciones.reduce((acc,comprobacion) => {
				if(comprobacion.satisfactoria != null){
					acc.push({
						idMantenimientoComprobacion: comprobacion.idMantenimientoComprobacion,
						respuesta: comprobacion.respuesta,
						satisfactoria: comprobacion.satisfactoria,
						resuelto: comprobacion.satisfactoria || comprobacion.resuelto,
						comentario: comprobacion.comentario,
						idsDocumentos: comprobacion.idsDocumentos,
						notas: comprobacion.notas
					});
				}
				return acc;
			},[]);

			axios
				.put("/Mecanicos/MecanicoPausar", {
					idMantenimientoTarea: this.actividad.idMantenimientoTarea,
					idMantenimientoCalendarioInspeccion:
						this.actividad.idMantenimientoCalendarioInspeccion,
					comprobaciones
				})
				.then(() => {
					this.leaving = false;
					this.$emit("click:salir");
					setTimeout(() => {
						this.resetValores();
					}, 200);
				})
				.catch((error) => {
					this.leaving = false;
					if (error.response) {
						this.$refs.dialogInfo.showDialogNotificacion(
							"Ocurrió un error",
							"Se ha presentado un error. Intente nuevamente",
							"mdi-close-circle",
							"error"
						);
					}
					console.log(error);
				});
		},
		onClickSalir() {
			this.leaving = true;

			axios
				.put("/Mecanicos/MecanicoSalir", {
					idMantenimientoTarea: this.actividad.idMantenimientoTarea,
					idMantenimientoCalendarioInspeccion:
						this.actividad.idMantenimientoCalendarioInspeccion,
				})
				.then(() => {
					this.leaving = false;
					this.$emit("click:salir");
					setTimeout(() => {
						this.resetValores();
					}, 200);
				})
				.catch((error) => {
					this.leaving = false;
					if (error.response) {
						this.$refs.dialogInfo.showDialogNotificacion(
							"Ocurrió un error",
							"Se ha presentado un error. Intente nuevamente",
							"mdi-close-circle",
							"error"
						);
					}
					console.log(error);
				});
		},
		onRefresh() {
			this.resetErrores();
			this.resetValores();
			this.initialize();
		},
		initialize() {
			this.getComprobaciones();
		},
		resetValores() {
			this.comprobaciones = [];
			this.mecanicos = [];
			this.recomendacion = null;
			this.kilometraje = null;
			this.horasTrabajadas = null;
			this.inicioCronometro = 0;
		},
		resetErrores() {
			this.errores = [];
			
			for (const key in this.erroresItem) {
				this.$set(this.erroresItem,key,null);
			}

			for (const comprobacion of this.comprobaciones) {
				for (const key in comprobacion) {
					if(key.toLocaleLowerCase().includes('error'))
						this.$set(comprobacion,key,null);
				}
			}
		},
		validate() {
			this.resetErrores();
			let hayErroresComprobaciones = false;

			this.comprobaciones.forEach((comprobacion) => {
				if(comprobacion.tipoComprobacion != null){
					if(!comprobacion.respuesta){
						this.$set(comprobacion, "errorRespuesta", "Requerido");
						hayErroresComprobaciones = true;
					}
				}
				if (comprobacion.satisfactoria == null) {
					this.$set(comprobacion, "errorSatisfactoria", "Requerido");
					hayErroresComprobaciones = true;
				} else if (comprobacion.satisfactoria == false) {
					if (comprobacion.resuelto == null) {
						this.$set(comprobacion, "errorResuelto", "Requerido");
						hayErroresComprobaciones = true;
					}
				}
			});

			if(this.esIndasa && this.actividad.tipo != 4){
				if(this.esCategoriaEspecifica('transportes')){
					const parsedKilometraje = parseFloat(this.kilometraje);
					const parsedKilometrajeMin = parseFloat(this.kilometrajeMin);
					if(isNaN(parsedKilometraje) || isNaN(parsedKilometrajeMin) ) this.erroresItem.errorKilometraje = "Invalido";
					else if(parsedKilometraje < 0) this.erroresItem.errorKilometraje = "No puede ser negativo";
					else if (parsedKilometrajeMin > 0 && parsedKilometraje < parsedKilometrajeMin) this.erroresItem.errorKilometraje = "Debe ser mayor o igual al kilometraje mínimo";
				}

				if(this.esCategoriaEspecifica('montacargas')){
					const parsedHoras = parseFloat(this.horasTrabajadas);
					if(isNaN(parsedHoras)) this.erroresItem.errorHorasTrabajadas = "Requerido";
					else if(parsedHoras < 0) this.erroresItem.errorHorasTrabajadas = "Debe ser mayor o igual a 0";
				}
			}

			if(this.esIndasa && !this.recomendacion){
				this.erroresItem.errorRecomendacion = "Requerido";
			}

			let hayErrores = Object.values(this.erroresItem).some( value => value != null) || hayErroresComprobaciones;

			if(hayErrores) this.errores = ["Hay uno o mas errores, porfavor reviselos y vuelva a intentarlo"];

			return !hayErrores;
		},
		onClickFinalizar() {
			if (!this.validate()) return;

			if (this.mecanicos.length > 1) {
				this.$refs.dialogAlerta.showDialogNotificacion(
					"Advertencia",
					"Al enviar el reporte de comprobaciones se cerrarán las sesiones de los demás mecánicos involucrados en la actividad.<br>¿Desea continuar?",
					"mdi-alert",
					"deep-orange"
				);
			} else {
				this.enviarComprobaciones();
			}
		},
		enviarComprobaciones() {
			this.saving = true;

			const payload = {
				idMantenimientoTarea: this.actividad.idMantenimientoTarea,
				idMantenimientoCalendarioInspeccion:
					this.actividad.idMantenimientoCalendarioInspeccion,
				recomendacion: this.recomendacion,
				kilometraje: parseFloat(this.kilometraje) || null,
				horasTrabajadas: parseFloat(this.horasTrabajadas) || null,
				comprobaciones: this.comprobaciones.map((comprobacion) => ({
					idMantenimientoComprobacion: comprobacion.idMantenimientoComprobacion,
					respuesta: comprobacion.respuesta,
					satisfactoria: comprobacion.satisfactoria,
					resuelto: comprobacion.satisfactoria || comprobacion.resuelto,
					comentario: comprobacion.comentario,
					idsDocumentos: comprobacion.idsDocumentos,
					notas: comprobacion.notas
				})),
			};

			axios({
				url:
					this.actividad.tipo == 3
						? "/Mecanicos/TerminarInspeccion"
						: "/Mecanicos/TerminarTareaMantenimiento",
				method: "PUT",
				data: payload,
			})
				.then(() => {
					this.saving = false;
					this.$refs.dialogSuccess.showDialogNotificacion(
						"Reporte enviado",
						"Se ha enviado el reporte correctamente",
						"mdi-check-circle",
						"success"
					);
				})
				.catch((error) => {
					this.saving = false;
					if (error.response) {
						this.$refs.dialogInfo.showDialogNotificacion(
							"Ocurrió un error",
							"Se ha presentado un error. Intente nuevamente",
							"mdi-close-circle",
							"error"
						);
					}
					console.log(error);
				});
		},
		getComprobaciones(bypass = false) {
			if (!bypass) this.loading = true;

			axios({
				url:
					this.actividad.tipo == 3
						? `/Mecanicos/MantenimientoInspeccionComprobaciones/${this.actividad.idMantenimientoCalendarioInspeccion}`
						: `/Mecanicos/TareaMantenimientoComprobaciones/${this.actividad.idMantenimientoTarea}`,
				method: "GET",
			})
				.then((response) => {
					if (!bypass){
						this.comprobaciones = response.data.comprobaciones.map(comprobacion => {
							if(comprobacion.registro == null) return comprobacion;
							return {
								...comprobacion,
								...comprobacion.registro
							}
						});

						this.inicioCronometro = this.actividad.tiempoPeriodosMs > 0
							? this.actividad.tiempoPeriodosMs
							: this.actividad.inicioCronometro || response.data.inicioCronometro;
					}
					this.mecanicos = response.data.mecanicos;
				})
				.catch((error) => {
					this.resetValores();
					console.log(error);
				})
				.finally(() => {
					if (!bypass) this.loading = false;
				});                                                                           
		},
	},
};
</script>
<style scoped>
.divider-dashed {
	border: 2px dashed rgba(0,0,0,.33) !important;
}

.custom-error-message >>> .v-messages {
	font-size: 16px;
}

.custom-error-message >>> .v-messages__message {
	line-height: 16px;
}
</style>